import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NProfiles } from '../profile.interfaces';

/**
 * Resolver to load CMS block for the member edit page
 */
export const memberEditResolver: ResolveFn<NProfiles.IMemberEditContent | undefined> = async () => {
    const iCmsBlockResource = inject(ICmsBlockResource);
    const block = await iCmsBlockResource.retrieve<NProfiles.IMemberEditContent>(
        { bareUrl: NProfiles.COMPONENT_IDS.memberEdit },
        undefined
    );
    return block && block instanceof Object ? (block.data?.content as NProfiles.IMemberEditContent) : undefined;
};
